import React, {PropTypes} from 'react';
import {Field} from 'redux-form';
import DisplayIf from 'shared/DisplayIf.jsx';
import MinimalField from 'shared/MinimalField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import TagItem from './TagItem.jsx';

const TagPanel = ({
  isAddingTag,
  onAddTagClick,
  onCancelClick,
  onRemoveTagClick,
  onSaveClick,
  onTagChange,
  onTagNameChange,
  tags,
  tournamentTags,
  value
}) => (
<div className="panel panel-default">
  <div className="panel-heading">
    <h4 className="panel-title">
      <span>{'Tags'}</span>
      <div className="float-right">
        <button type="button"
          className="btn btn-link pull-right"
          onClick={onAddTagClick}>
            <i className="fa fa-plus"/> {'Create New Tag'}
        </button>
      </div>
    </h4>
  </div>
  <div className="panel-body">
    <Field
      name="tagId"
      component={StandardSelectField}
      options={tags}
      placeholder="Available Tags"
      label="Choose your Tag:"
      simpleValue
      searchable={false}
      onCustomChange={onTagChange}
    />
    <DisplayIf condition={isAddingTag}>
      <Field
        classString="form-group flex"
        name="tournamentTagName"
        type="text"
        component={MinimalField}
        placeholder="Tag"
        //onCustomChange={e => onTagNameChange(e.target.value)}
      >
        <button
          type="button"
          className="btn btn-primary-brand"
          onClick={() => onCancelClick()}
          >{'Cancel'}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => onSaveClick(value)}
          >{'Save'}
        </button>
      </Field>
    </DisplayIf>
    <div className="list-group">
      {tournamentTags && tournamentTags.map((item, index) => (
        <TagItem key={index}
          {...item}
          onRemoveTagClick={onRemoveTagClick}
        />
      ))}
    </div>
  </div>
</div>
);

TagPanel.propTypes = {
  isAddingTag: PropTypes.bool,
  onAddTagClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onRemoveTagClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  onTagChange: PropTypes.func,
  onTagNameChange: PropTypes.func,
  tags: PropTypes.arrayOf(PropTypes.object),
  tournamentTags: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string
};

TagPanel.defaultProps = {
  isAddingTag: false,
  tags: [],
  tournamentTags: []
};

export default TagPanel;


// WEBPACK FOOTER //
// ./src/features/tournament/general/TagPanel.jsx